<template>
  <div
    class="layout-grid mx-72 border-t border-t-grey-light-01 py-40 mobile-only:hidden"
  >
    <ul class="bg col-span-full flex justify-center gap-36">
      <li>
        <div class="flex justify-end">
          <SpriteSymbol
            name="card"
            class="h-24 w-24 -translate-y-2 scale-150 stroke-[.7] text-grey-dark-02"
          />
          <span
            class="ml-[20px] h-24 text-[14px] font-light uppercase text-grey-dark-02"
          >
            {{ $texts('safePayment', 'Safe Payment') }}
          </span>
        </div>
      </li>
      <li>
        <div class="flex justify-end">
          <SpriteSymbol
            name="shipping"
            class="h-[20px] w-[26px] text-grey-dark-02"
          />
          <span
            class="ml-[20px] h-24 text-[14px] font-light uppercase text-grey-dark-02"
          >
            {{ $texts('freeShipping', 'Free Shipping') }}
          </span>
        </div>
      </li>
      <li>
        <div class="flex justify-end">
          <SpriteSymbol
            name="gift"
            class="h-24 w-24 -translate-y-4 scale-150 stroke-[.7] text-grey-dark-02"
          />
          <span
            class="ml-[20px] h-24 text-[14px] font-light uppercase text-grey-dark-02"
          >
            {{ $texts('freeReturns', 'Free returns') }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const { $texts } = useEasyTexts()
</script>
